export function saveToFile(content: any, filename: string, type: string) {
	const link = document.createElement('a');
	link.download = filename;
	link.href = URL.createObjectURL(new Blob([content], { type }));
	link.click();
}
